module.exports = __webpack_public_path__ + "static/img/male.eb7560aa.jpg";